import type { ReactNode } from "react";
import { themeClasses, type Theme } from "@cw/design-tokens/theme";
import { ContainedSection, SectionHeader } from "../primitives/Section";

/** Long-form MDX body. `lede` renders the "larger text" line the CEO's notes refer to. */
export function RichText({ eyebrow, heading, lede, children, theme = "paper", width = "prose", id }: { eyebrow?: string; heading?: string; lede?: string; children?: ReactNode; theme?: Theme; width?: "prose" | "full"; id?: string }) {
  const t = themeClasses(theme);
  return (
    <ContainedSection theme={theme} id={id}>
      <div className={width === "prose" ? "max-w-[72ch]" : ""}>
        <SectionHeader eyebrow={eyebrow} heading={heading} theme={theme} />
        {lede ? <p className={`${t.heading} text-display-sm font-display font-semibold`}>{lede}</p> : null}
        <div className={`${t.prose} ${t.body} ${lede ? "mt-6" : ""} text-lg`}>{children}</div>
      </div>
    </ContainedSection>
  );
}
